<div class="flex flex-row justify-between mx-8 mt-4">
  <a href="https://www.pvsmartclick.com/home-calculator?source=OTP_BANK_REDIRECT" target="_blank"
     rel="noopener noreferrer">
    <img src="assets/svg/pvc-logo-color.svg" alt="PVSmartClick logo" class="h-6 md:h-10">
  </a>
  <img src="assets/svg/otp_logo_colored.svg" alt="OTP bank logo" class="h-6 md:h-10">
</div>
<div class="p-4 flex flex-col items-center relative" *transloco="let t; read: 'home'">
  <div class="md:w-[95%] flex flex-col md:flex-row">
    <div class="w-full" [ngClass]="{'md:w-[60%] flex-1': calculationResultWrapper}">
      <psc-simple-calculator
        [colorConfig]="colorConfig"
        (resultCalculated)="onCalculationEnded($event)"
      ></psc-simple-calculator>
    </div>

    <div class="flex flex-col items-center relative md:w-[40%]"
         *ngIf="calculationResultWrapper" @inOutAnimation>
      <psc-simple-solar-calculation-result
        [colorConfig]="colorConfig"
        class="w-[90%]"
        [result]="calculationResultWrapper"></psc-simple-solar-calculation-result>
      <ng-container *transloco="let g; read 'home.calculator.map'">
        <psc-button
          class="mt-6"
          size="small"
          [type]="colorConfig.secondaryButtonType"
          @inOutAnimation
          (buttonClicked)="startFromBeginning()"
          [label]="g('start_from_beginning')">
        </psc-button>
      </ng-container>
    </div>
  </div>
</div>
